import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { INSAutoCompleteOption } from '@norfolk-southern/accessns-components';
import { Observable } from 'rxjs';

import * as PermitActions from '@ruby/modules/unit-train/store/actions/permit.actions';
import * as UTFiltersSearchActions from '@ruby/modules/unit-train/store/actions/ut-filters-search.actions';
import * as PermitSelectors from '@ruby/modules/unit-train/store/selectors/permit.selectors';

@Component({
  selector: 'ng-permit-search-container',
  templateUrl: './permit-search.container.html'
})
export class PermitSearchContainer {
  store$: Observable<{ commodities: Array<INSAutoCompleteOption>; permitsFound: Array<INSAutoCompleteOption>; searchingPermits: boolean }>;

  constructor(private store: Store) {
    this.store$ = this.store.select(PermitSelectors.selectSearchPermits);
    this.store.dispatch(UTFiltersSearchActions.getCommodities());
  }

  /**
   * Search Permits
   *
   * @summary Dispatch action to search permits
   * @param $value: { commodity: string; search: string }
   * @return void
   */
  searchPermits($value: { commodity: string; search: string }): void {
    this.store.dispatch(PermitActions.searchPermits({ data: $value }));
  }

  /**
   * Load Permit
   *
   * @summary Dispatch action to load
   * @param $permit: { permitName: string; permitId: string; permitType: string }
   * @return void
   */
  loadPermit($permit: { permitName: string; permitId: string; permitType: string }): void {
    this.store.dispatch(PermitActions.loadPermit({ data: $permit }));
  }
}
